var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.verificaAmbiente())?_c('div',{attrs:{"id":"faixa"}},[_vm._v(_vm._s(_vm.retornaAmbiente()))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }